const Component_ScrollHandler = () => {
	// Funktion zur Überprüfung der Scroll-Position
	const updateHeaderClass = () => {
		const header = document.querySelector("header");
		if (!header) return; // Sicherstellen, dass das Header-Element existiert

		// Wenn der Benutzer ganz oben ist
		if (window.scrollY === 0) {
			header.classList.add("at-top");
			header.classList.remove("scroll");
		} else {
			header.classList.remove("at-top");
			header.classList.add("scroll");
		}
	};

	// Klassen standardmäßig setzen (falls sie fehlen)
	const header = document.querySelector("header");
	if (header) {
		header.classList.add("scroll");
		if (window.scrollY === 0) {
			header.classList.add("at-top");
		}
	}

	// Initiale Prüfung nach dem Laden der Seite
	window.addEventListener("load", updateHeaderClass);

	// Event-Listener für Scroll-Events
	window.addEventListener("scroll", updateHeaderClass);

	return null;
};

export default Component_ScrollHandler;
